import * as React from 'react';
import { visualize, story, snap } from 'storybook-snapper';
import { Tooltip, TooltipProps, TooltipSkin } from '..';
import { classes } from './Tooltip.visual.st.css';

const defaultProps: TooltipProps = {
  content:
    'Etiam id nisl id ante volutpat porta. Aliquam eu luctus ante. Morbi in quam nec magna eleifend scelerisque.',
  children:
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. In commodo gravida tortor a posuere.',
  shown: true,
  appendTo: 'window',
};

const TooltipWrapper: React.FC<TooltipProps> = (props) => (
  <div style={{ margin: '300px' }}>
    <Tooltip {...defaultProps} {...props} />
  </div>
);

visualize('Tooltip', () => {
  story('render', () => {
    snap('default', () => <TooltipWrapper {...defaultProps} />);
    snap('error', () => (
      <TooltipWrapper skin={TooltipSkin.Error} {...defaultProps} />
    ));
    snap('wired', () => (
      <TooltipWrapper skin={TooltipSkin.Wired} {...defaultProps} />
    ));
    snap('bottom', () => (
      <TooltipWrapper {...defaultProps} placement="bottom" />
    ));
    snap('left', () => <TooltipWrapper {...defaultProps} placement="left" />);
    snap('right', () => <TooltipWrapper {...defaultProps} placement="right" />);
    snap('maxWidth', () => <TooltipWrapper {...defaultProps} maxWidth={150} />);
    snap('wst override', () =>
      <TooltipWrapper
        skin={TooltipSkin.Wired}
        className={classes.wstStyled}
        {...defaultProps}
      />
    );
  });
});
